import { Button, Dropdown, Grid } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import LoginController from "./loginController/LoginController";
import SFULogoDesktopSVG from "../../assets/svgs/sfu-logo-header-desktop.svg";
import SFULogoMobileSVG from "../../assets/svgs/sfu-logo-header-mobile.svg";

const MyHeader = () => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const location = useLocation();

  useEffect(() => setIsDropdownVisible(false), [location]);

  const screens = Grid.useBreakpoint();
  const breakpoint = screens.md;

  return breakpoint ? (
    <header>
      <div
        className="sfu-white-background"
        style={{ padding: "20px 0", height: 100 }}
      >
        <Link to="/">
          <img
            src={SFULogoDesktopSVG}
            alt="SFU Logo"
            style={{ height: 60, verticalAlign: "baseline" }}
          />
        </Link>

        <Link to="/">
          <span
            className="sfu-title-link sub-heading-font"
            style={{ paddingLeft: 32, fontSize: 26 }}
          >
            RESEARCH EXPERTISE ENGINE
          </span>
        </Link>
      </div>
      <LoginController />
    </header>
  ) : (
    <>
      <header style={{ position: "sticky", top: '0vh', zIndex: 10 }}>
        <div
          className="sfu-red-background"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link to="/">
            <img src={SFULogoMobileSVG} alt="SFU Logo" style={{ height: 50 }} />
          </Link>
          <Dropdown
            overlay={<LoginController />}
            trigger={["click"]}
            placement="bottomRight"
            getPopupContainer={(triggerNode: HTMLElement) => {
              // To set the container of the dropdown menu. The default is to create a div element in body, but you can reset it to the scrolling area and make a relative reposition.
              // => Fix LoginController (<Menu />) relative to triggerNode (<Button> 4 lines below)
              return triggerNode;
            }}
            visible={isDropdownVisible}
            onVisibleChange={(visible: boolean) => setIsDropdownVisible(visible)}
          >
            <Button
              className="sub-heading-font sfu-white-text sfu-red-background"
              type="text"
              style={{ height: 50, borderWidth: 0 }}
            >
              <MenuOutlined
                style={{ paddingRight: 4 }}
              />
              MENU
            </Button>
          </Dropdown>
        </div>
      </header>
      <div style={{ margin: "16px 16px 8px", fontSize: 20 }}>
        <Link to="/">
          <span className="sfu-title-link sub-heading-font">
            RESEARCH EXPERTISE ENGINE
          </span>
        </Link>
      </div>
    </>
  );
};

export default MyHeader;
